var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"danger","size":"sm"},on:{"click":_vm.confirmDelete}},[_c('i',{staticClass:"fas fa-trash-alt fa-fw"}),_vm._v(" Supprimer les échéances cochées\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }